<!--
 SELECT
------------------------------------
사용 예 )
------------------------------------
옵션 출력
    <app-input-select
        :options="[{text: '옵션1', val: 'a'}, {text: '옵션2', val: 'b'}]"
    > </app-input-select>
------------------------------------
값 바인딩 : 일반 텍스트 바인딩
    <app-input-select
        value="b"
        :options="[{text: '옵션1', val: 'a'}, {text: '옵션2', val: 'b'}]"
    > </app-input-select>

------------------------------------
값 바인딩 : 부모 컴포넌트의 data 바인딩
    <app-input-select
        :value="columns.p_name"
        :options="[{text: '옵션1', val: 'a'}, {text: '옵션2', val: 'b'}]"
    > </app-input-select>

------------------------------------
값 바인딩 : 부모 컴포넌트의 data v-model 처리
    <app-input-select
        v-model="columns.p_name"
        :options="[{text: '옵션1', val: 'a'}, {text: '옵션2', val: 'b'}]"
    > </app-input-select>

------------------------------------
값 바인딩 : 부모 컴포넌트 에서 값변경 이벤트 리스닝 
    <app-input-select
        :value="vvv"
        @update:value="val => vvv = val "
        :options="[{text: '옵션1', val: 'a'}, {text: '옵션2', val: 'b'}]"
    > </app-input-select>
    {{ vvv }}

    <script>
    {
        data: {
            vvv: null
        }
    }
    </script>

------------------------------------
값 바인딩 : 부모 컴포넌트 sync 처리
    <app-input-text
        :value.sync="vvv"
        :options="[{text: '옵션1', val: 'a'}, {text: '옵션2', val: 'b'}]"
    > </app-input-text>
    {{ vvv }}

    <script>
    {
        data: {
            vvv: null
        }
    }
    </script>

------------------------------------
사이즈 설정
    <app-input-text
        input-size="small or large"
        :options="[{text: '옵션1', val: 'a'}, {text: '옵션2', val: 'b'}]"
    > </app-input-text>

------------------------------------
id, name, placeholder 설정
    - 셀렉트 박스는 placeholder 기능 제공하지 않음 
    <app-input-select
        id="aaa"
        name="bbb"
    > </app-input-select>

------------------------------------
검증 설정 - 검증규칙 객체를 넘기는 경우
    <app-input-select
        v-model="vvv"
        :validate-rules="{required: true, title: 'title'}"
        :options="[{text: '옵션1', val: 'a'}, {text: '옵션2', val: 'b'}, {text: '옵션3', val: ''}]"
    > </app-input-select>

    <script>
    {
        data: {
            vvv: null
        }
    }
    </script>

------------------------------------
검증 설정 - 프라미스 생성 함수명을 넘기는 경우
    <app-input-select
        v-model="vvv"
        validate-rules="func_name"
        :options="[{text: '옵션1', val: 'a'}, {text: '옵션2', val: 'b'}, {text: '옵션3', val: ''}]"
    > </app-input-select>
    
    <script>
    {
        data: {
            vvv: null
        }
    }
    </script>

------------------------------------
포커싱 기능 - 요소를 선택하면 색상이 하이라이트됨

------------------------------------
setFocus() - 요소에 포커싱 설정
    <app-input-select
        ref="aaa"
    > </app-input-select>

    <button type="button" @click="$refs.aaa.inputFocus()">포커싱</button>

------------------------------------
setError() - 요소를 검증오류로 설정
    <app-input-select
        ref="aaa"
    > </app-input-select>

    <button type="button" @click="$refs.aaa.setState('error', '오류메세지')">오류설정</button>
-->
<template>
    <div :class="classObject" :style="[defaultCssVariables, cssVariables]">
        <select
                class="uk-select"
                :id="id"
                :name="name"
                :class=" inputSizeClass"

                @input="updateValue"
                @focus="focus"
                @focusout="focusout"
        >
            <option
                    v-for="(option, index) in options"
                    :value="option.val"
                    :selected="selectedIndex === index"
            >
                {{ option.text }}
            </option>
        </select>
    </div>
</template>

<script>
    import InputBase from './base.vue';
    export default {
        extends: InputBase,
        computed: { 
            /**
             * 현재 선택된 index를 반환
             */
            selectedIndex: function () {
                var value = this.value;
                var selected = null;
                 _.find(this.options, function (option, index) {
                     if (value == option.val) {
                         selected = index;
                        return true;
                     }
                     return false;
                });
                return selected;
            }
        }
    }
</script>